import type { PoGetConfigResponse } from '@repo/sdk/gen'
import type { TKey } from '@/lib/i18n'

export const REGION_LABEL_KEYS = {
	LAZIO: 'esclusive:regions.lazio',
	CAMPANIA: 'esclusive:regions.campania',
	PUGLIA: 'esclusive:regions.puglia',
	CALABRIA: 'esclusive:regions.calabria',
	SICILIA: 'esclusive:regions.sicilia',
	SARDEGNA: 'esclusive:regions.sardegna',
	ABRUZZO: 'esclusive:regions.abruzzo',
	UMBRIA: 'esclusive:regions.umbria',
	TOSCANA: 'esclusive:regions.toscana',
	BASILICATA: 'esclusive:regions.basilicata',
	MOLISE: 'esclusive:regions.molise'
} as const satisfies Record<
	PoGetConfigResponse['data']['config']['esclusive'][number]['regions'][number],
	TKey
>

// Checked against the SDK by the map above: a region the backend adds or drops
// fails the build there.
export type Region = keyof typeof REGION_LABEL_KEYS

// Ordered by weight on sales, not alphabetically: whoever reads the grid starts
// from Lazio and Campania.
export const REGIONS = [
	'LAZIO',
	'CAMPANIA',
	'PUGLIA',
	'CALABRIA',
	'SICILIA',
	'SARDEGNA',
	'ABRUZZO',
	'UMBRIA',
	'TOSCANA',
	'BASILICATA',
	'MOLISE'
] as const satisfies readonly Region[]

// Region sets compare by content: the backend returns them in its own order.
export function sameRegions(a: readonly Region[], b: readonly Region[]) {
	return a.length === b.length && a.every((region) => b.includes(region))
}
